
import { useState } from "react";
import MainLayout from "@/components/layout/MainLayout";
import EmotionDashboardHeader from "@/components/dashboard/EmotionDashboardHeader";
import EmotionSummaryCards from "@/components/dashboard/EmotionSummaryCards";
import EmotionChartSection from "@/components/dashboard/EmotionChartSection";
import EmotionRecentEntries from "@/components/dashboard/EmotionRecentEntries";
import PageSEO from "@/components/seo/PageSEO";

const EmotionDashboard = () => {
  const [timeRange, setTimeRange] = useState("30days");

  const breadcrumbs = [
    {
      position: 1,
      name: "Início",
      item: "https://metrocalma.org/app"
    },
    {
      position: 2,
      name: "Dashboard de Emoções",
      item: "https://metrocalma.org/dashboard-emocoes"
    }
  ];

  return (
    <MainLayout>
      <PageSEO 
        title="Dashboard de Emoções - metrocalma | Acompanhamento Emocional Inteligente"
        description="Monitore e analise suas emoções com gráficos inteligentes, insights personalizados e recomendações baseadas em seu padrão emocional."
        canonicalUrl="https://metrocalma.org/dashboard-emocoes"
        keywords="dashboard emoções, monitoramento emocional, análise humor, saúde mental, bem-estar emocional"
        pageName="Dashboard de Emoções"
        breadcrumbs={breadcrumbs}
      />
      
      <EmotionDashboardHeader timeRange={timeRange} setTimeRange={setTimeRange} />
      <EmotionSummaryCards />
      <EmotionChartSection />
      <EmotionRecentEntries />
    </MainLayout>
  );
};

export default EmotionDashboard;
